import modules_menu from './menu/index.js'
import _actions_set_style from './_actions/set_style.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    actions:{
        set_style: _actions_set_style,
    },
    modules:{
        menu: modules_menu,
    },
}